module.exports = __webpack_public_path__ + "static/media/recentfiles.4bd9ab5b.gif";